module.exports = __webpack_public_path__ + "media/images/icons/check-white-e81c54a2206d226cfdda770e49ee7a7f.svg";